<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2024-01-02 14:33:11
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-06 14:28:34
 * @FilePath: /gamefi/components/Casino/History/GameDetaliModal/index.vue
-->
<template>
    <ModalTitle
        class=""
        containerClass="max-w-[96vw]"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <template v-slot:header>
            <div class="p-3 flex justify-between flex-1">
                <span>
                    {{ t.GameDetails.UserProfile }}
                </span>
            </div>
        </template>
        <!-- 
            ↑ 顶部标题
            ↓ 窗口主体部分 
        -->
        <div
            v-if="isIncognito"
            :ref="(el) => (contentRef = el)"
            class="max-h-[80vh] overflow-auto !overflow-x-hidden text-white space-y-4"
        >
            <CasinoHistoryModalUserProfilePreview :profile="profile" />
            <!-- ↓ 用户的游戏信息 -->
            <!-- <CasinoHistoryModalUserProfileTopPlayedGames :profile="profile" /> -->
        </div>
        <div v-else>
            <CasinoHistoryModalUserProfilePreview :profile="profile" class="pb-5" />
            <div
                :ref="(el) => (contentRef = el)"
                class="inline-flex w-full items-center justify-center gap-2 py-4 rounded-md bg-[#161f2c]"
            >
                <IconSvgUse use="icon-data-hidden" class="text-grey-40 w-7 h-7" />
                <span class="text-grey-40">Incognito</span>
            </div>
        </div>
    </ModalTitle>
</template>

<script lang="ts" >
export default defineComponent({name: 'ProfileDialog'});
</script>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import { useUserStore } from '~/stores/user';
import { useProfileSocket } from '~/socket/profile';
import type { UserProfileCurrenciesResponseState } from '~/socket/profile/dto';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    userId: {
        type: [String, Number],
        // required: true, // 非必填，因为此窗口没收到特定 id 时将使用当前用户id 查看自已的资料 
    },
    forSelf: Boolean, // 若为 true 表示在查看自已的信息
});

const userStore = useUserStore();
const { EMIT_PROFILE_USER_STATISTIC } = useProfileSocket();
const t = useTranslation();
const contentRef = ref(null);
const profile = ref({} as UserProfileCurrenciesResponseState);

const emits = defineEmits(['update:modelValue']);
// ↓ 匿名标识 
const isIncognito = computed(() => {
    return !profile.value?.userStatistic?.isGameDataHidden;
});

watch(
    () => props.modelValue,
    (newValue) => {
        if (!newValue) {
            emits('update:modelValue', false);
            return;
        };
        // ↑ 不处理关窗口
        // ↓ 打开窗口时查询数据
        const userId = props.forSelf ? userStore.id : props.userId;
        const oPrams = {
            userId: String(userId), 
        };
        EMIT_PROFILE_USER_STATISTIC(oPrams, (data) => {
            if (1 && import.meta.dev){
                console.log("用户信息窗口：\n", deepCopy(data));
            }
            if (!data) return;
            profile.value = data;
        },);
    },
    {
        immediate: true,
    },
);
</script>
